import api from './api';

// Match the existing web transport. The mobile GET-body contract still needs
// backend verification for these query parameters before release.
export function readSearchResponse(response) {
  const envelope = response?.data || {};
  if (envelope.error || Number(envelope.code) >= 400 || !envelope.dataset?.data) {
    throw new Error(envelope.message || 'Unable to load search content.');
  }
  return envelope.dataset.data;
}

export function normalizeSearchPage(data, page = 1, series = false) {
  const list = series ? data.quiz_list : data.search_list;
  return {
    items: Array.isArray(list) ? list : [],
    total: Number(data.total_result ?? data.pagination?.totalRecords ?? 0),
    categoryId: Number(data.category_id),
    categoryName: data.category_name || '',
    keyword: data.search_text || '',
    stateName: data.state_name || '',
    currentPage: Number(data.pagination?.currentPage || page),
    totalPages: Number(data.pagination?.totalPages || 1),
  };
}

export async function fetchSearchResults({ categoryId, keyword, searchLogId, page = 1 }, { signal } = {}) {
  const response = await api.get('/get-all-filter-content', {
    params: { page, category_id: categoryId, search_log_id: searchLogId, search: keyword }, signal,
  });
  return normalizeSearchPage(readSearchResponse(response), page);
}

export async function fetchSearchSeriesQuizzes({ seriesId, stateId, page = 1 }, { signal } = {}) {
  const response = await api.get('/quiz/quiz-list', {
    params: { page, states_id: stateId, category_id: 1, series_id: seriesId }, signal,
  });
  return normalizeSearchPage(readSearchResponse(response), page, true);
}

const DETAIL_ENDPOINTS = {
  2: ['/get-question-detail', 'question_id'],
  3: ['/lectures/get-lecture-detail', 'lecture_id'],
  4: ['/notes/get-note-detail', 'note_id'],
};

export async function fetchSearchDetail({ categoryId, id, keyword }, { signal } = {}) {
  const [endpoint, idField] = DETAIL_ENDPOINTS[categoryId] || [];
  if (!endpoint || !id) throw new Error('Open a search result to view its details.');
  return readSearchResponse(await api.get(endpoint, {
    params: { category_id: categoryId, [idField]: id, search_term: keyword || '' }, signal,
  }));
}

export function ensureActionSuccess(result) {
  if (result?.meta?.error || Number(result?.meta?.code) >= 400) {
    throw new Error(result.meta.message || 'Unable to save this change.');
  }
  return result;
}

export async function fetchSearchCategories(search, { signal } = {}) {
  const response = await api.get('/get-all-filter-content-categories', {
    params: { search },
    signal,
  });
  const envelope = response?.data || {};
  if (envelope.error || Number(envelope.code) >= 400 || !envelope.dataset?.data) {
    throw new Error(envelope.message || 'Unable to load search categories.');
  }
  const data = envelope.dataset.data;
  return {
    categories: Array.isArray(data.search_list) ? data.search_list : [],
    searchLogId: Number(data.search_log_id) || 0,
    limitReached: Number(data.limit_reach ?? 0) !== 0,
    message: envelope.message || '',
  };
}
